var map = {
	"./antOutline-arrow-left Copy.svg": "cgnA",
	"./antOutline-control.svg": "cR/T",
	"./antOutline-insurance.svg": "hHpt",
	"./fa5-stethoscope.svg": "r9Wt",
	"./farfa-money-bill-alt.svg": "9hSL",
	"./fasfa-paper-plane.svg": "yXnu",
	"./iconPark-add-user.svg": "PVl/",
	"./iconPark-add-user2.svg": "35TU",
	"./iconPark-bookshelf.svg": "iVbX",
	"./iconPark-classroom.svg": "jFPi",
	"./iconPark-financing-one.svg": "pRne",
	"./iconPark-find-one.svg": "hP5f",
	"./iconPark-flash-payment.svg": "JxZu",
	"./iconPark-monitor-off.svg": "RPtW",
	"./iconPark-monitor.svg": "daJb",
	"./iconPark-pesticide.svg": "ZWtJ",
	"./iconPark-power.svg": "USCL",
	"./iconPark-preschool.svg": "JJGl",
	"./iconPark-voice-off.svg": "5mP4",
	"./iconPark-voice.svg": "A2en",
	"./if-database.svg": "EI0f",
	"./if-history.svg": "BjbG",
	"./if-prescription.svg": "kNLh",
	"./md-account_balance_wallet.svg": "XtDi",
	"./md-attach_file.svg": "Trpt",
	"./md-chevron_right.svg": "61Mi",
	"./md-grade.svg": "0tj8",
	"./md-location_on.svg": "Tc2i",
	"./md-lock_outline.svg": "AM9D",
	"./md-navigate_before.svg": "zzxV",
	"./md-shopping_cart.svg": "zMIQ",
	"./password.svg": "74Gh",
	"./riLine-file-list-3-line.svg": "EyUx",
	"./riLine-vip-line.svg": "IcJE",
	"./stLine-cloud-upload-l.svg": "Nhtk",
	"./user.svg": "EOg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 22